import { RECOMMENDED_TYPES } from 'constant'

const normalizeGBBToBVIds = gBBDetails =>
  RECOMMENDED_TYPES.reduce((acc, cur) =>
    gBBDetails[cur] && gBBDetails[cur].bvId ?
      [...acc, gBBDetails[cur].bvId] : acc
  , [])

const normalizeRecordsToBVIds = records =>
  records.filter(el =>
    (el.attributes && el.attributes.bvId) ?
      Array.isArray(el.attributes.bvId) ? !!el.attributes.bvId[0] : !!el.attributes.bvId : false)
    .map(el => Array.isArray(el.attributes.bvId) ? el.attributes.bvId[0] : el.attributes.bvId)

export const getBVIds = ({ records, allRecords, bvId, frontTire, gBBDetails, BOTProductSearchResults }) => {
  let bvIds = []
  if (allRecords) {
    bvIds = normalizeRecordsToBVIds(allRecords)
  } else if (records && !BOTProductSearchResults) {
    bvIds = normalizeRecordsToBVIds(records)
  } else if (bvId) {
    bvIds = [bvId]
  } else if (frontTire && frontTire.bvId) {
    bvIds = [frontTire.bvId]
  } else if (gBBDetails) {
    bvIds = normalizeGBBToBVIds(gBBDetails)
  }
  return bvIds
}
